<template>
  <div id="input-interface" :style="{ width }">
    <div class="ii-image">
      <img :src="image" width="20">
    </div>
    <div class="ii-value">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputInterface',
  props: {
    width: {
      type: String,
      default: () => '100%'
    },
    image: {
      type: String,
      default: () => '/img/phone.png'
    }
  },
  data: function() {
    return {
    }
  }
}
</script>
